import { Helmet } from 'react-helmet';
import React from 'react';
import { Container } from '@material-ui/core';
import CreditMatrix from './CreditMatrix';
import LoanMatrix from './LoanMatrix';

export default function LeasingMatrix() {

  return (
    <div>
      <Helmet>
        <title>Matryca kredytu i pożyczki | GO-auto - Panel administracyjny</title>
      </Helmet>

      <Container className="credit-loan-container">
        <CreditMatrix />
        <LoanMatrix />
      </Container>
        
    </div>
  )
}
